import * as types from 'store/mutation-types'
import api from 'store/api'
import Vue from 'vue'

const _isFalsy = val =>
_.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = val => !_isFalsy(val)

const requestCancel = {
    token: Vue.axios.CancelToken,
    source: null
}

const    state = {
      cart:[],
      active_cart:[],
      carts:[],
      uid: 0,
      requestCancel
    }

const    mutations = {

      [types.CARTS_RECEIVED] (state, payload) {
          state.carts = [].concat(payload)
      },

      [types.CART_RECEIVED] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_CREATED] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_ACTIVE_RECEIVED] (state, payload) {
          state.active_cart = [].concat(payload)
      },

      [types.CART_ACTIVE_CLEAN] (state, payload) {
          state.active_cart = this.fetchActiveCart({commit:types.CART_ACTIVE_RECEIVED})
      },

      [types.CART_UPDATED] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_SET_CURRENT_STEP] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_SET_OWNER] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_SET_PASSING_CUSTOMER] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_ATTACH_TO_CUSTOMER] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_RESET_OWNER] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_ADD_OFFER] (state, payload) {
          // state.active_cart = this.fetchActiveCart({commit:types.CART_ACTIVE_RECEIVED})
      },

      [types.CART_RECOMPUTE_PRICE] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_CHANGE_DOM_OFFER] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_CLEAN] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_PURCHASE_TUNNEL_MANIFEST] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_PURCHASE_STEPS] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_PURCHASE_CART_STEP] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_PURCHASE_CONNECTION_STEP] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.CART_TUNNEL_INFORMATION_STEP_EDITION_STATUS] (state, payload) {
          state.cart = [].concat(payload)
      },

      [types.REQUEST_TOKEN_SOURCE_CHANGED] (state, source) {
        state.requestCancel.source = source
      },

      [types.CART_SUBORDER_DELETE] (state, payload) {
          // state.active_cart = [this.fetchActiveCart({commit:types.CART_ACTIVE_RECEIVED})]
      },

      [types.CART_SUBORDER_UPDATE_QUANTITY] (state, payload) {
          // state.active_cart = [this.fetchActiveCart({commit:types.CART_ACTIVE_RECEIVED})]
      },

    }

const   actions = {

        initializeCart ({dispatch, state, commit}) {

            dispatch('fetchActiveCart', {params:{}, commit:types.CART_ACTIVE_RECEIVED}).then((response) =>
            {
              if (_.isNil(state.active_cart[0]) || state.active_cart.length === 0)
              {
                dispatch('createCart', {params:{}, commit:types.CART_CREATED})
                  .then(() => dispatch('fetchActiveCart', {params:{}, commit:types.CART_ACTIVE_RECEIVED}))
              }
            })
        },

        fetchCarts ({commit, getters}, params) {
          // console.info("Fetching Carts " + params.commit)
          return api.fetchCarts(params.params)
                    .then(response => commit(params.commit, response.data.carts))
        },

        fetchCartById ({commit, getters}, params) {
          // console.info("Fetching Cart By Id " + params.commit )
          return api.fetchCartById(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        createCart({dispatch, commit, getters}, params) {
          // console.info("Creating an new cart")
          return api.createCart(params.params)
                    .then(response => commit(types.CART_CREATED, response.data.cart))
        },

        fetchActiveCart({commit, getters, actions}, params) {
          // console.info("Fetching the active cart")
          return api.fetchActiveCart(params)
                    .then(response => commit(types.CART_ACTIVE_RECEIVED, response.data.cart))
        },

        setCurrentStepForCart({commit, getters}, params) {
          // console.info("SetCurrentStepForCart")
          return api.setCurrentStepForCart(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        setOwnerForCart({commit, getters}, params) {
          // console.info("SetOwnerForCart")
          return api.setOwnerForCart(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        passingCustomerForCart({commit, getters}, params) {
          // console.info("PassingCustomerForCart")
          return api.passingCustomerForCart(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        attachCartToCustomer({commit, getters}, params) {
          // console.info("AttachCustomerForCart")
          return api.attachCartToCustomer(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        resetCartOwner({commit, getters}, params) {
          // console.info("ResetCartOwner")
          return api.resetCartOwner(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        addOfferToCart({dispatch, commit, getters}, params) {
          console.warn(params.params)
          var tmp = params.params.price * params.params.quantity
          params.params.price = tmp
          console.warn(params.params)
          return api.addOfferToCart(params.cartId, params.params)
                    .then(response => {
                      commit(types.CART_ADD_OFFER, response.data.cart)
                      dispatch('fetchActiveCart')
                    })
        },

        computePriceAgainForCart({commit, getters}, params) {
          // console.info("computePriceAgainForCart")
          return api.computePriceAgainForCart(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        changeDomiciliationOffer({commit, getters}, params) {
          // console.info("changeDomiciliationOffer")
          return api.changeDomiciliationOffer(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        cleanCart({dispatch, commit, getters}, params) {
          // console.info("cleanCart")
          return api.cleanCart(params.cartId, {_method:"PUT"})
                    .then(response => dispatch('fetchActiveCart'))
        },

        getPurchaseManifest({commit, getters}, params) {
          // console.info("getPurchaseManifest")
          return api.getPurchaseManifest(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        getPurchaseSteps({commit, getters}, params) {
          // console.info("getPurchaseSteps")
          return api.getPurchaseSteps(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        getPurchaseCartSteps({commit, getters}, params) {
          // console.info("getPurchaseCartSteps")
          return api.getPurchaseCartSteps(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        getPurchaseTunnelConnectionStep({commit, getters}, params) {
          // console.info("getPurchaseTunnelConnectionStep")
          return api.getPurchaseTunnelConnectionStep(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        getPurchaseInformationStepEditionStatus({commit, getters}, params) {
          // console.info("getPurchaseInformationStepEditionStatus")
          return api.getPurchaseInformationStepEditionStatus(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        // Cart company
        getCartCompanyIndex({commit, getters}, params) {
          // console.info("getCartCompanyIndex")
          return api.getCartCompanyIndex(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        createCartCompany({commit, getters}, params) {
          // console.info("createCartCompany")
          return api.createCartCompany(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        storeCompanyCart({commit, getters}, params) {
          // console.info("StoreCompanyCart")
          return api.storeCompany(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        editCartCompany({commit, getters}, params) {
          // console.info("EditCompanyCart")
          return api.editCartCompany(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        updateCartCompany({commit, getters}, params) {
          // console.info("UpdateCompanyCart")
          return api.updateCartCompany(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        delCartCompany({commit, getters}, params) {
          // console.info("delCartCompany")
          return api.delCartCompany(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        // Cart Suborder
        storeSuborders({commit, getters}, params) {
          // console.info("storeSuborders")
          return api.storeSuborders(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        updateSuborders({commit, getters}, params) {
          // console.info("updateSuborders")
          return api.updateSuborders(params.cartId, params.offerId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        updateSubordersQuantity({commit, getters}, params) {
          // console.info("updateSubordersQuantity" + params.params)
          return api.updateSubordersQuantity(params.cart_id, params.suborder_id, {quantity:params.params.quantity, _method:params.params._method})
                    .then(response => commit(types.CART_SUBORDER_UPDATE_QUANTITY, response.data.cart))
        },

        updateSubordersInformation({commit, getters}, params) {
          // console.info("updateSubordersInformation")
          return (api.updateSubordersInformation(params.cartId, params.offerId, params.params)
                .then(response => commit(params.commit, response.data.cart)))
        },

        deleteSuborders({dispatch, commit, getters}, params) {
          // console.info("deleteSuborders")
          return api.deleteSuborders(params.cart_id, params.suborder_id, {})
                    .then(response => commit(types.CART_SUBORDER_DELETE, response.data.cart))
        },

        // Cart Suborder options
        storeSubordersOptions({commit, getters}, params) {
          // console.info("storeSubordersOptions")
          return api.storeSubordersOptions(params.cartId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        updateSubordersOptions({commit, getters}, params) {
          // console.info("updateSubordersOptions")
          return api.updateSubordersOptions(params.cartId, params.offerId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

        deleteSuborderOptions({commit, getters}, params) {
          // console.info("deleteSuborderOptions")
          return api.deleteSuborderOptions(params.cartId, params.offerId, params.params)
                    .then(response => commit(params.commit, response.data.cart))
        },

    }

const   getters = {
        carts(state, getters, params) {
          return state.carts
        },

        cart(state, getters, params) {
          return state.cart
        },

        active_cart(state, getters, params)
        {
          return state.active_cart
        }
    }

export default {
  namespaced:true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./client/store/modules/cart.js